module.exports = __webpack_public_path__ + "img/icon_kh.f082f399.png";